import { render, staticRenderFns } from "./AdministrativePermitsSearchPerson.vue?vue&type=template&id=ad7aebe8&scoped=true"
import script from "./AdministrativePermitsSearchPerson.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsSearchPerson.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePermitsSearchPerson.vue?vue&type=style&index=0&id=ad7aebe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7aebe8",
  null
  
)

export default component.exports